import React from "react";
import { useSelector } from "react-redux";

const AddButton = ({ onAddDataClick, filterChilds }) => {
  const darkMode = useSelector((state) => state.theme.darkMode);
  return (
    <div style={{ marginLeft: "auto" }}>
      <div
        style={{ display: "flex", justifyContent: "flex-end", marginRight: 3 }}
      >
        <div>
          <button
            type="button"
            className={
              darkMode ? "btn btn-block btn-add-dark" : "btn btn-block btn-add"
            }
            style={{
              borderRadius: 8,
              border: !darkMode ? "1px solid black" : "1px solid white",
              color: !darkMode ? "black" : "white",
            }}
            onClick={onAddDataClick}
          >
            <i className="fa fa-plus" /> Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddButton;
